export const SingleTourNavbarItems: { name: string, id: string }[] = [
    {name: 'Home', id: 'home'},
    // {name: 'About', id: 'about'},
    {name: 'Tours', id: 'tours'},
    {name: 'Map', id: 'map'},
    // {name: 'Contact', id: 'footer'}
];
